import { render, staticRenderFns } from "./ProductTile.vue?vue&type=template&id=6511907b&scoped=true&"
import script from "./ProductTile.ts?vue&type=script&lang=ts&"
export * from "./ProductTile.ts?vue&type=script&lang=ts&"
import style0 from "./ProductTile.vue?vue&type=style&index=0&id=6511907b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6511907b",
  null
  
)

export default component.exports